import { apiGet } from './api';

export function getDashboardStats() {
  return apiGet('/api/dashboard');
}
